import React, { Component, Fragment } from "react";
import { Checkbox, Tabs } from "antd";
import ButtonStep from "./../../ButtonStep";
import _ from "lodash";
import SectorsView from "./SectorsView";
import RegionalesView from "./RegionalesView";
import PDCsView from "./PDCsView";

const TabPane = Tabs.TabPane;
const CheckboxGroup = Checkbox.Group;

class SurveyStepSecteur extends Component {
  componentDidMount() {}

  next = current => {
    this.props.handleDisabled(true);
    this.props.next(current);
  };

  render() {
    const { current, steps, prev, sucess, currentSectors, currentPDCs } = this.props;
    const disabled = currentSectors.length === 0 && currentPDCs.length === 0;
    return (
      <Fragment>
        <ButtonStep
          current={current}
          steps={steps}
          prev={() => prev(current)}
          next={() => this.next(current)}
          sucess={() => sucess(current)}
          disabled={disabled}
        />
        <div className="p-txt-italic">- Définir les cibles :</div>
        <div className="p-mrg-top">
          <Tabs
            defaultActiveKey="1"
            onChange={() => {
            }}
          >
            <TabPane tab="Secteurs" key="1">
              <SectorsView currentSectors={this.props.currentSectors} />
            </TabPane>
            <TabPane tab="Points de contact" key="2">
              <PDCsView />
            </TabPane>
            <TabPane tab="Centrales Régionales" key="3">
              <RegionalesView currentRegionales={this.props.currentRegionales} />
            </TabPane>
          </Tabs>
        </div>
      </Fragment>
    );
  }
}

export default SurveyStepSecteur;



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepSecteur/SurveyStepSecteur.js